"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bisection = exports.calculateBreakevenPointsForALine = void 0;
const calculationsCore_1 = require("../calculationsCore");
const calculateBreakevenPointsForALine = (domain, positions, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, usdUsdcIndex, y) => {
    let res = [];
    if (y[0] === 0) {
        res.push(domain[0]);
    }
    if (y[domain.length - 1] === 0) {
        res.push(domain[domain.length - 1]);
    }
    const pnlPerPoint = pnlCurried(positions, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, usdUsdcIndex);
    for (let i = 0; i < y.length - 1; i++) {
        // We get sometimes NaN values in line. No time to check it.
        if (Math.sign(y[i]) !== Math.sign(y[i + 1]) &&
            !isNaN(y[i]) &&
            !isNaN(y[i + 1])) {
            const root = (0, exports.bisection)(domain[i], domain[i + 1], pnlPerPoint);
            res.push(root);
        }
    }
    return res;
};
exports.calculateBreakevenPointsForALine = calculateBreakevenPointsForALine;
const pnlCurried = (positions, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, usdUsdcIndex) => {
    return (x) => {
        const { todayLine } = (0, calculationsCore_1.calculatePositionsPnl)([x], positions, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, usdUsdcIndex);
        return todayLine[0];
    };
};
const bisection = (a, b, fn, EPSILON = 0.01) => {
    if (Math.abs(fn(a)) <= EPSILON) {
        return a;
    }
    if (Math.abs(fn(b)) <= EPSILON) {
        return b;
    }
    let left = a;
    let mid = a;
    let right = b;
    let counter = 0;
    while (Math.abs(right - left) >= EPSILON || counter === 100) {
        mid = (left + right) / 2;
        if (Math.sign(fn(mid)) === Math.sign(fn(left))) {
            left = mid;
        }
        else {
            right = mid;
        }
        counter++;
    }
    return mid;
};
exports.bisection = bisection;
